import LoadHelper from '@exp/exp-utils/helper/load';
const _pageLoadHelper = new LoadHelper();

export default _pageLoadHelper;
